var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame44(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "User",
    d: "M2.81738 14.8732V13.781C2.85867 12.97 3.34618 12.2487 4.08333 11.9081C7.55944 10.5118 11.4405 10.5118 14.9166 11.9081C15.6537 12.2487 16.1412 12.97 16.1825 13.781V14.8732C16.1822 15.4644 15.9469 16.0313 15.5285 16.449C15.11 16.8667 14.5426 17.1009 13.9514 17.1H5.04853C4.45728 17.1009 3.88993 16.8667 3.47145 16.449C3.05297 16.0313 2.81767 15.4644 2.81738 14.8732ZM9.49995 1.89999C7.99803 1.89956 6.64375 2.80395 6.06868 4.19143C5.49362 5.5789 5.81103 7.17617 6.8729 8.23834C7.93476 9.30052 9.53194 9.6184 10.9196 9.04374C12.3072 8.46908 13.212 7.11506 13.212 5.61314C13.2123 4.62845 12.8213 3.684 12.1252 2.98761C11.429 2.29123 10.4846 1.89999 9.49995 1.89999Z",
    fill: "currentColor"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame44);
export default __webpack_public_path__ + "static/media/Frame (44).05c8cc01f69da70ec76fe4c39338300b.svg";
export { ForwardRef as ReactComponent };